export const formatMeasurement = (value, type) => {
  if (value === null || value === undefined || value === "") return "-";

  const numericValue = Number(value);

  if (isNaN(numericValue)) return "-";

  const config = {
    weight: 3,
    dimension: 2,
  };

  const decimals = config[type] ?? 0;

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
